import { CommandBar, ICommandBarProps } from '@fluentui/react';

export interface IPCommandBarProps extends ICommandBarProps {}

export const IPCommandBar = (props: IPCommandBarProps) => {
  return <CommandBar {...props} />;
};
